import { createFileRoute, redirect } from '@tanstack/react-router';

import type { RouterContext } from '@shared/config/router-context';
import { canAccessAnalyticsMove } from '@shared/lib';

/**
 * Analytics - Weekly Report Detail
 *
 * Route: /:locale/analytics/weekly/:weekId
 */
export const Route = createFileRoute('/$locale/_authenticated/analytics/weekly/$weekId')({
  beforeLoad: ({ context, params, search }) => {
    const { ability } = context as RouterContext;

    if (!canAccessAnalyticsMove(ability)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/$locale/unauthorized',
        params: { locale: params.locale },
      });
    }

    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/$locale/analytics-move/weekly/$weekId',
      params: { locale: params.locale, weekId: params.weekId },
      search,
    });
  },
});
